import { Image } from '@teamfoster/sdk/image';

const url = [
  '//coda.fstr.io/media/SK-CODA-PAPERART23-116.jpg',
  '//coda.fstr.io/media/PaperArt-2023-141.jpg',
  '//coda.fstr.io/media/museum_craft.jpg',
  '//coda.fstr.io/media/SK_CODA-25723-7.jpg',
  '//coda.fstr.io/media/museum_kinos.jpg',
  '//coda.fstr.io/media/museum_educatie.jpg',
  '//coda.fstr.io/media/museum_rondleiding.jpg',
  '//coda.fstr.io/media/museum_tentoonstellingen4.jpg',
  '//coda.fstr.io/media/museum_tentoonstellingen1.jpg',
  '//coda.fstr.io/media/museum_tentoonstellingen2.jpg',
  '//coda.fstr.io/media/museum_tentoonstellingen3.jpg',
  '//coda.fstr.io/media/museum_ADO.jpg',
  '//coda.fstr.io/media/museum_cpa.jpg',
  '//coda.fstr.io/media/PaperArt-2023-021.jpg',
  '//coda.fstr.io/media/museum_performance.jpg',
  '//coda.fstr.io/media/museum_educatie en programmering3.jpg',
  '//coda.fstr.io/media/museum_CODA Atelier - header_alternatief 2.jpg',
  '//coda.fstr.io/media/museum_CODA Atelier_header - alternatief.jpg',
  '//coda.fstr.io/media/PaperArt-2023-041.jpg',
  '//coda.fstr.io/media/museum_atelierbackup.jpg',
  '//coda.fstr.io/media/museum_corbino.jpg',
  '//coda.fstr.io/media/museum_basis.jpg',
  '//coda.fstr.io/media/PaperArt-2023-018.jpg',
  '//coda.fstr.io/media/musem_tentoonstellingen.jpg',
  '//coda.fstr.io/media/museum_atelier.jpg',
];

export const image: Image[] = url.map(a => ({ url: a, alt: 'Voorbeeld afbeelding' }));

// Needs to be an embed url, so only replace id
export const testVideo: string = 'https://www.youtube.com/embed/dVOf-5GXIoM';
